var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 406.518,
    height: 411.931,
    viewBox: "0 0 406.518 411.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vector_17",
    x: 0,
    y: 0,
    width: 406.518,
    height: 411.931,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f2efff",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    "data-name": "Vector 18",
    d: "M62.023,0C22.786,74.972,95.656,155.9,172.029,129.275c-37.5,64.169-110.207,59.486-147.492,20.67S-12.949,30.479,62.023,0Z",
    transform: "translate(0 25.428) rotate(-8.5)",
    fill: "#f2efff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(120 90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -120, -90)",
    filter: "url(#Vector_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17-2",
    "data-name": "Vector 17",
    d: "M62.023,0C22.786,74.972,95.656,155.9,172.029,129.275c-37.5,64.169-110.207,59.486-147.492,20.67S-12.949,30.479,62.023,0Z",
    transform: "translate(120 115.43) rotate(-8.5)",
    fill: "#f2efff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_group",
    "data-name": "Mask group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_18-2",
    "data-name": "Vector 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(76.157 146)",
    fill: "rgba(23,29,75,0.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(140.157 116)",
    fill: "rgba(23,29,75,0.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(41.157 66)",
    fill: "rgba(23,29,75,0.17)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon17);
export default __webpack_public_path__ + "static/media/evolbs_icon17.0ecfa0b6.svg";
export { ForwardRef as ReactComponent };